export class WebSpeechSTT {
    available;
    #rec = null;
    constructor() {
        const Ctor = globalThis.SpeechRecognition ?? globalThis.webkitSpeechRecognition;
        this.available = typeof Ctor === "function";
        if (this.available) {
            this.#rec = new Ctor();
            this.#rec.continuous = false;
            this.#rec.interimResults = true;
            this.#rec.lang = "en-US";
        }
    }
    start(onFinal, onInterim) {
        const rec = this.#rec;
        if (!rec)
            return;
        rec.onresult = (e) => {
            let interim = "";
            let final = "";
            for (let i = e.resultIndex; i < e.results.length; i++) {
                const r = e.results[i];
                if (r.isFinal)
                    final += r[0].transcript;
                else
                    interim += r[0].transcript;
            }
            if (interim && onInterim)
                onInterim(interim);
            if (final)
                onFinal(final.trim());
        };
        rec.onerror = () => { };
        try {
            rec.start();
        }
        catch {
            /* already started */
        }
    }
    stop() {
        try {
            this.#rec?.stop();
        }
        catch {
            /* ignore */
        }
    }
}
export class WebSpeechTTS {
    available;
    constructor() {
        this.available = typeof globalThis.speechSynthesis !== "undefined";
    }
    speak(text) {
        if (!this.available || !text.trim())
            return;
        const synth = globalThis.speechSynthesis;
        const u = new globalThis.SpeechSynthesisUtterance(text);
        u.rate = 1.02;
        synth.speak(u);
    }
    cancel() {
        if (this.available)
            globalThis.speechSynthesis.cancel();
    }
}
/** A "yes/no" grammar for voice confirmations. */
export function affirmative(transcript) {
    return /^\s*(yes|yeah|yep|sure|ok|okay|do it|go ahead|allow|confirm)\b/i.test(transcript);
}
//# sourceMappingURL=voice.js.map